import { oz } from '@weft/utils';
import { AggregationAverageMethodSchema } from './aggregation-method-with-field-schemas/average';
import { AggregationDistinctMethodSchema } from './aggregation-method-with-field-schemas/distinct';
import { AggregationFirstMethodSchema } from './aggregation-method-with-field-schemas/first';
import { AggregationLastMethodSchema } from './aggregation-method-with-field-schemas/last';
import { AggregationMaxMethodSchema } from './aggregation-method-with-field-schemas/max';
import { AggregationMinMethodSchema } from './aggregation-method-with-field-schemas/min';
import { AggregationSumMethodSchema } from './aggregation-method-with-field-schemas/sum';
import { AggregationWithoutFieldMethodSchema } from './aggregation-method-without-field-schema';

export const AggregationMethodSchema = oz.discriminatedUnion('operator', [
  AggregationWithoutFieldMethodSchema,
  AggregationSumMethodSchema,
  AggregationAverageMethodSchema,
  AggregationDistinctMethodSchema,
  AggregationFirstMethodSchema,
  AggregationLastMethodSchema,
  AggregationMaxMethodSchema,
  AggregationMinMethodSchema,
]).openapi('AggregationMethod');

export type AggregationMethod = oz.infer<typeof AggregationMethodSchema>;